import { defineMessages } from 'react-intl';

const messages = defineMessages({
  admissionPolicy: {
    id: 'hubs.admissions.application-info.imp-policies.admission-policy',
    defaultMessage: 'Admission Policy',
  },
  notificationPolicy: {
    id: 'hubs.admissions.application-info.imp-policies.notification-policy',
    defaultMessage: 'Notification Policy',
  },
  earlyDecision: {
    id: 'hubs.admissions.application-info.imp-policies.early-decision',
    defaultMessage: 'Early Decision',
  },
  waitList: {
    id: 'hubs.admissions.application-info.imp-policies.wait-list',
    defaultMessage: 'Wait List',
  },
  testOptional: {
    id: 'hubs.admissions.application-info.imp-policies.test-optional',
    defaultMessage: 'Test Optional',
  },
  commonApp: {
    id: 'hubs.admissions.application-info.imp-policies.common-app',
    defaultMessage: 'Accepts Common App',
  },
  coalitionApp: {
    id: 'hubs.admissions.application-info.imp-policies.coalition-app',
    defaultMessage: 'Accepts Coalition App',
  },
  registrationPolicy: {
    id: 'hubs.admissions.application-info.imp-policies.registration-policy',
    defaultMessage: 'Registration Policy',
  },
  testOptionalTooltip: {
    id: 'hubs.admissions.application-info.imp-policies.test-optional-tooltip',
    defaultMessage: `Although general admission to an institution may be test optional, some academic programs within the institution may nonehteless require a test score as part of the admissions process. Check with the institution for more information.`,
  },
  coalitionAppWebsite: {
    id: 'hubs.admissions.application-info.imp-policies.coalition-app-website',
    defaultMessage: `Coalition Application website`,
  },
  applied: {
    UNKNOWN: {
      id: 'hubs.admissions.application-info.imp-policies.applied-UNKNOWN',
      defaultMessage: `You've added a Common App college to your "colleges I'm applying to" list, but haven't indicated if you plan to apply via the Common App Online.`,
    },
    COMMONAPP: {
      id: 'hubs.admissions.application-info.imp-policies.applied-COMMONAPP',
      defaultMessage: `You've opted to apply to this college electronically via Common App.`,
    },
    DOCUFIDE: {
      id: 'hubs.admissions.application-info.imp-policies.applied-DOCUFIDE',
      defaultMessage: `This college accepts documents electronically via Naviance.`,
    },
    PRINT: {
      id: 'hubs.admissions.application-info.imp-policies.applied-PRINT',
      defaultMessage: `This college does not accept documents electronically, all documents must be submitted via mail.`,
    },
    DOCCA: {
      id: 'hubs.admissions.application-info.imp-policies.applied-DOCCA',
      defaultMessage: `You've added a Common App college to your "colleges I'm applying to" list, but opted to not to apply via Common Online. However you may be able to to still submit forms, transcripts, and letters of recommendation electronically.`,
    },
    CA_PRINT: {
      id: 'hubs.admissions.application-info.imp-policies.applied-CA_PRINT',
      defaultMessage: `You've added a Common App college to your "colleges I'm applying to" list, but opted to not to apply via Common App Online. However, the school is not an electronic destination so you will have to print and mail school forms, transcripts and letters of recommendation to the destination.`,
    },
    COALITION: {
      id: 'hubs.admissions.application-info.imp-policies.applied-COALITION',
      defaultMessage: `You've indicated you are applying via the Coalition Application. You must upload the forms directly to the`,
    },
    COALITION_EXC: {
      id: 'hubs.admissions.application-info.imp-policies.applied-COALITION_EXC',
      defaultMessage: `You've indicated you are applying via the Coalition Application. You must upload the forms directly to the`,
    },
  },
  nonApplied: {
    UNKNOWN: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-UNKNOWN',
      defaultMessage: `You've added a Common App college to your "colleges I'm applying to" list, but haven't indicated if you plan to apply via the Common App Online.`,
    },
    COMMONAPP: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-COMMONAPP',
      defaultMessage: `You've opted to apply to this college electronically via Common App.`,
    },
    DOCUFIDE: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-DOCUFIDE',
      defaultMessage: `This college accepts documents electronically via Naviance.`,
    },
    PRINT: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-PRINT',
      defaultMessage: `This college does not accept documents electronically, all documents must be submitted via mail.`,
    },
    DOCCA: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-DOCCA',
      defaultMessage: `You've added a Common App college to your "colleges I'm applying to" list, but opted to not to apply via Common Online. However you may be able to to still submit forms, transcripts, and letters of recommendation electronically.`,
    },
    CA_PRINT: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-CA_PRINT',
      defaultMessage: `You've added a Common App college to your "colleges I'm applying to" list, but opted to not to apply via Common App Online. However, the school is not an electronic destination so you will have to print and mail school forms, transcripts and letters of recommendation to the destination.`,
    },
    COALITION: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-COALITION',
      defaultMessage: `This college accepts applications via the Coalition Application. You must upload the forms directly to the`,
    },
    COALITION_EXC: {
      id: 'hubs.admissions.application-info.imp-policies.non-applied-COALITION_EXC',
      defaultMessage: `This college accepts applications via the Coalition Application. You must upload the forms directly to the`,
    },
  },
});

export default messages;
